<template>
  <div id="result-table">
    <vs-table max-items="30" pagination :data="datas" no-data-text="loading...">
      <template slot="thead">
        <vs-th>No.</vs-th>
        <vs-th>Date</vs-th>
        <vs-th>Start</vs-th>
        <vs-th>Start Show</vs-th>
        <vs-th>Show 1st & 2nd</vs-th>
        <vs-th></vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :key="index" v-for="(tr, index) in data">
          <vs-td>
            {{ index+1 }}
          </vs-td>
          <vs-td>
            {{ tr.lotto_date }}
          </vs-td>
          <vs-td>
            {{ startTime(tr.start_spin) }}
          </vs-td>
          <vs-td>
            {{ startTime(tr.show_2nd) }}
          </vs-td>
          <vs-td>
            {{ startTime(tr.show_1st) }}
          </vs-td>
          <vs-td>
            <vs-button class="float-right ml-2" color="danger" icon-pack="feather" icon="icon-trash" @click="deleteData(tr.lotto_id)">Delete</vs-button>
            <vs-button class="float-right" color="warning" icon-pack="feather" icon="icon-edit" @click="editData(tr.lotto_id)">Edit</vs-button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>
<script>
import LottoService from "@/services/lottoService"

import moment from "moment"

export default {
  data() {
    return {
      results: []
    }
  },
  computed: {
    datas() {
      return this.results
    },
    lottoType() {
      return this.$route.params.lottoType
    }
  },
  watch: {
    lottoType() {
      this.loadResults()
    }
  },
  methods: {
    loadResults() {
      LottoService.getResults(this.$route.params.lottoType).then((response) => {
        this.results = response.datas
      })
    },
    deleteData(id) {
      if (confirm('ต้องการลบ?')) {
        console.log(id)
        LottoService.deleteResult(this.$route.params.lottoType, id).then((response) => {
          if (response.status === 'success') {
            this.loadResults()
            this.$vs.notify({
              title: 'สำเร็จ!',
              text: 'ลบข้อมูลเสร็จเรียบร้อย',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'
            });
          } else {
            this.$vs.notify({
              title: 'ผิดพลาด!',
              text: 'ลบข้อมูลไม่สำเร็จ',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
          }
        })
      }
    },
    editData(id) {
      console.log(id)
      this.$router.push({ name: 'admin-edit-results', params: { lottoType: this.$route.params.lottoType, resultId: id } })
    },
    startTime(datetime) {
      if (datetime) {
        return moment(datetime).format("YYYY-MM-DD HH:mm")
      } else {
        return '-'
      }
    }
  },
  created() {
    this.loadResults()
  }
}

</script>
<style lang="scss">
#result-table {
  button.vs-button {
    padding: 0.5rem 1rem !important;
  }
}

</style>
